export default "/images/ru.png?655901719258edf1988ec81770bf4400";